export default __webpack_public_path__ + "static/media/livro9.d3249713.png";